import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { clearState, setPin as SetPin, unlockUsingPin } from 'src/slices/auth'
import { handleStatus } from 'src/slices/utils'
import { useEventListener } from 'src/utils/useEventListener'
import css from './Keypad.module.scss'

export default function Keypad({ mode, editFunction, enterFunction, closeFunction }) {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const [pin, setPin] = useState('')
	const { status } = useSelector(state => state.auth)

	const numbers = [7, 8, 9, 4, 5, 6, 1, 2, 3]
	const validatePin = pin => {
		if (pin.length != 6) {
			toast.warning('Pin must be 6 digits long')
			return null
		}
		return true
	}
	useEffect(() => {
		handleStatus(status.setPin, () => dispatch(clearState(status.setPin)), {
			isSuccess: {
				callback: () => {
					closeFunction()
				},
			},
		})
	}, [status.setPin])

	useEffect(() => {
		handleStatus(status.unlockUsingPin, () => dispatch(clearState(status.unlockUsingPin)), {
			isSuccess: {
				callback: () => {
					navigate('/profile')
				},
			},
			isError: {
				callback: () => {
					shakeElement()
				},
			},
		})
	}, [status.unlockUsingPin])
	function handleSubmit() {
		if (mode == 'edit') {
			if (validatePin(pin)) {
				dispatch(SetPin(pin.join('')))
			}
		}
		if (mode === 'enter') {
			dispatch(unlockUsingPin(pin.join('')))
		}
	}

	function addNumber(num) {
		if (pin.length < 6) {
			// using array here because JavaScript creates a new array on every keyListener event thus not updating state correctly
			// https://stackoverflow.com/questions/71010357/react-state-not-updating-on-key-event
			setPin(pin => [...pin, num.toString()])
		}
	}

	function removeNumber() {
		if (pin.length > 0) {
			setPin(pin => pin.slice(0, -1))
		}
	}

	function handleKeyClick(num) {
		addNumber(num)
	}

	function handleDelClick() {
		removeNumber()
	}

	function handleKeyDown(e) {
		if (!isNaN(e.key)) {
			// ⚠ Commented this because multiple timeouts lead to an unexpected effect.
			// Some keys stay highlighted if user types too fast.
			// Uncomment if you know how to fix it, or if you think users will not type too fast (not recommended)

			// let pressedKey = `k${e.key}`;
			// setAnimationState({ ...animationState, [pressedKey]: "running" });
			// setTimeout(function () {
			//     setAnimationState({
			//         ...animationState,
			//         [pressedKey]: "paused",
			//     });
			// }, 100);
			addNumber(e.key)
		} else if (e.key == 'Backspace') {
			removeNumber()
		} else if (e.key == 'Enter') {
			handleSubmit()
		}
	}

	const [shake, setShake] = useState(false)

	function shakeElement() {
		setShake(true)
		setTimeout(function () {
			setShake(false)
		}, 820)
	}

	useEventListener('keydown', handleKeyDown)

	const [animationState, setAnimationState] = useState({
		k1: 'paused',
		k2: 'paused',
		k3: 'paused',
		k4: 'paused',
		k5: 'paused',
		k6: 'paused',
		k7: 'paused',
		k8: 'paused',
		k9: 'paused',
		k0: 'paused',
	})

	return (
		<div className={css.pad}>
			<p className={`${css.pin} ${shake ? css.shake : ''}`}>{pin}</p>
			<div className={css.keys}>
				{numbers.map(num => (
					<button
						key={`key ${num}`}
						className={`${css.key} ${
							animationState[`k${num}`] === 'running' ? css['dii'] : ''
						}`}
						onClick={() => handleKeyClick(num)}>
						{num}
					</button>
				))}

				<button
					key={`key del`}
					className={css.key + ' ' + css.del}
					onClick={() => handleDelClick('del')}>
					<i className='fal fa-backspace' />
				</button>

				<button
					key={`key 0`}
					className={css.key}
					onClick={() => handleKeyClick(0)}>
					0
				</button>

				<button
					key={`key accept`}
					className={css.key + ' ' + css.accept}
					onClick={() => handleSubmit()}>
					<i className={mode === 'edit' ? 'fal fa-sync-alt' : 'fal fa-key'} />
					<span>{mode === 'edit' ? 'Update PIN' : 'Enter'}</span>
				</button>
			</div>
		</div>
	)
}
